import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Card, Empty } from '../ui';

export function NotFound(): ReactElement {
  return (
    <div className="page">
      <Card flush>
        <Empty
          tone="bad"
          lead="There is nothing at this address."
          action={
            <Link to="/" className="btn">
              Today
            </Link>
          }
        >
          A link that used to work here would have said so. Check the address, or start from Today.
        </Empty>
      </Card>
    </div>
  );
}
